export default function hexToRgb(hex) {
  const hexArray =
    hex.length === 4
      ? [hex[1], hex[2], hex[3]]
      : [hex.slice(1, 3), hex.slice(3, 5), hex.slice(5, 7)]
  return hexArray.map(function (str) {
    return parseInt(str, 16)
  })
}
